import React from 'react';
import head from '../assets/head.png'
import AccountCard from './CardComponent';
import IconRow from './IconRow';
import MenuList from './MenuList';
import Navbar from '../General/Navbar';
import { LuPenLine } from "react-icons/lu";
import './home.scss'
import FloatingIcon from '../General/FloatingIcon';

function Home() {
  return (    
    <div >
        <di className='h'>
        <img src={head} alt="Logo" className='head'/>
        <div>
        <h1 > Hi</h1>
        <div>
        <h2 className='la'> Lama <LuPenLine  className='pen'/></h2>        
        </div>
        <p>UDI:1002966</p>        
    </div>    
    <div className='nom'>
            <p className='ben'>benjamin</p>
        </div>
        </di>
        <AccountCard/>
        <IconRow/>
        <MenuList/>
        <FloatingIcon/>
        <Navbar/>        
    </div>   
        
  )
}

export default Home